module.exports = __webpack_public_path__ + "static/media/armandomuis.0d514a7d.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/armandomuis.webp
// module id = 408
// module chunks = 0